import { render, staticRenderFns } from "./AdsActivitySetting.vue?vue&type=template&id=1946e4e4"
import script from "./AdsActivitySetting.vue?vue&type=script&lang=js"
export * from "./AdsActivitySetting.vue?vue&type=script&lang=js"
import style0 from "./AdsActivitySetting.vue?vue&type=style&index=0&id=1946e4e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports